import React from 'react';
import PropTypes from 'prop-types';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';
import { ROUTE_NAME, ROUTE_PATH } from 'utils/constants/router';

const useStyles = makeStyles((theme) => ({
  root: () => ({
    minHeight: '100%',
    overflow: 'unset',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white',
  }),
  providerRoot: {
    minHeight: 'unset',
    position: 'relative',
    height: 'calc(100% - 15px)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px 20px 5px !important',
    backgroundColor: '#F9EEF1',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100% - 20px)',
      padding: '15px 5px 5px !important',
    },
  },
  fixedHeight: {
    [theme.breakpoints.down('sm')]: ({ provider }) => ({
      height: provider ? '100%' : '93vh',
      minHeight: 0,
      overflowY: 'hidden',
    }),
  },
}));

const AppRouteContainer = ({ children }) => {
  const { appConfiguration: { providerSpecific } = {} } = useSelector((state) => state) ?? {};
  const classes = useStyles();
  const questionnaireMatchedRoute = useRouteMatch(ROUTE_PATH[ROUTE_NAME.QUESTIONNAIRE]);
  const className = cx(
    providerSpecific?.code ? classes.providerRoot : classes.root,
    { [classes.fixedHeight]: questionnaireMatchedRoute?.isExact },
  );

  return <div className={className} id="rootContainer">{children}</div>;
};

AppRouteContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppRouteContainer;
